import { Fragment, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "CommonComponents/Navbar/Navbar";
import FooterA from "Pages/Home/FooterA/FooterA";
import FooterB from "Pages/Home/FooterB/FooterB";
import HeroImage from "./HeroImage/HeroImage";
import MainSingleBlog from "./MainSingleBlog/MainSingleBlog";
import ReducerTypes from "Redux/Types/ReducerTypes";
import { dispatchItemToRedux, getSingleBlog } from "Redux/Actions";
import { useDispatch, useSelector } from "react-redux";
import { Spinner } from "react-bootstrap";

const SingleBlog = () => {
  // const blogId = useSelector((state) => state?.blog?.blogId?.id);
  const blog = useSelector((state) => state?.blog?.singleBlog?.items);
  const loading = useSelector((state) => state?.app?.appLoading);

  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const [_, , id] = pathname.split("/");
  useEffect(() => {
    dispatch(
      dispatchItemToRedux({
        type: ReducerTypes.BLOG_ID,
        payload: {
          id,
        },
      })
      );

      dispatch(getSingleBlog());
  }, [pathname]);

  return (
    <Fragment>
      <header>
        <Navbar />
      </header>
      <main>
        <HeroImage subject={blog.subject} medias={blog.medias}/>
        {loading ? (
          <div className=" w-100 text-center">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : (
          <MainSingleBlog singleBlog={blog} />
        )}
      </main>
      <footer>
        <FooterA />
        <FooterB />
      </footer>
    </Fragment>
  );
};

export default SingleBlog;
